import { RouteConfig } from 'vue-router'
import { prefixRoutes } from '../utils'
import chat from './builder/chat'
import profile from './builder/profile'

const builder: Array<RouteConfig> = [
  {
    path: '/',
    name: 'builder',
    component: () => import(/* webpackChunkName: "builder" */ '@/views/builder/Builder.vue'),

    children: [
      {
        path: ':id?',
        name: 'create',
        component: () =>
          import(/* webpackChunkName: "builder" */ '@/views/builder/BuilderCreate.vue'),
      },
      ...prefixRoutes(':id', [
        {
          path: 'created',
          name: 'profile-created',
          component: () =>
            import(/* webpackChunkName: "builder" */ '@/views/builder/BuilderProfileCreated.vue'),
        },
        {
          path: 'chat-created',
          name: 'chat-created',
          component: () =>
            import(/* webpackChunkName: "builder" */ '@/views/builder/BuilderChatCreated.vue'),
        },
        {
          path: 'chat-second-preview',
          name: 'chat-second-preview',
          component: () =>
            import(
              /* webpackChunkName: "builder" */ '@/views/builder/BuilderChatSecondPreview.vue'
            ),
        },
        {
          path: 'preview',
          name: 'preview',
          component: () =>
            import(/* webpackChunkName: "builder" */ '@/views/builder/BuilderPreview.vue'),
        },
      ]),
      ...profile,
      ...chat,
    ],
  },
]

export default builder
